import {
  ContactsSearchQuery,
  ContactsSearchModel,
  IResourceTabEnum,
  ResourceSearchQuery,
  ResourceSearchModel
} from 'capability-ng-resources';
import { ApplicationConfiguration } from '../../../models/app_config_model';
import * as _4 from 'lodash4';

export class MyResourcesController {
  private hasPlacesEnabled: boolean = true;
  private hasPeopleEnabled: boolean = true;
  public viewTitle: string;
  constructor(
    private $state: ng.ui.IStateService,
    private $stateParams: ng.ui.IStateParamsService,
    private appConfigModel: ApplicationConfiguration,
    private ResourceTabEnum: IResourceTabEnum,
    private ngResourceSearchModel: ResourceSearchModel,
    private ngResourceSearchQuery: ResourceSearchQuery,
    private ngContactsSearchModel: ContactsSearchModel,
    private ngContactsSearchQuery: ContactsSearchQuery
  ) {}
  $onInit() {
    this.hasPlacesEnabled = this.appConfigModel.isFeatureEnabled('inst-resource');
    this.hasPeopleEnabled = this.appConfigModel.isFeatureEnabled('ssccampus-campus_success_network');
    this.viewTitle = this.$state.current.data.viewTitle;
  }

  clearSearchTerms() {
    this.ngResourceSearchModel.write({ searchTerm: '' });
    this.ngResourceSearchQuery.run();
    this.ngContactsSearchModel.write({ searchTerm: '' });
    this.ngContactsSearchQuery.run();
  }
}

export class MyResourcesComponent implements angular.IComponentOptions {
  public templateUrl: string = 'lib/my_resources/views/my_resources/my_resources.html';
  public controller: any = MyResourcesController;
}



// WEBPACK FOOTER //
// ./app/lib/my_resources/views/my_resources/my_resources.ts